document.addEventListener('click', function (event) {
  // Handle size button clicks
  const button = event.target.closest('.card-size-selector__button');
  if (button) {
    event.preventDefault();
    event.stopPropagation();

    const wrapper = button.closest('.card-size-selector');
    wrapper.querySelectorAll('.card-size-selector__button').forEach((btn) =>
      btn.classList.remove('selected')
    );
    button.classList.add('selected');

    // Update price display for this product
    const productId = wrapper.dataset.productId;
    const priceDisplay = document.querySelector(
      `.card-price-display[data-product-id="${productId}"]`
    );
    if (priceDisplay && button.dataset.variantPrice) {
      priceDisplay.innerHTML = button.dataset.variantPrice;
    }

    // Enable Add to cart button
    const addBtn = wrapper.parentElement.querySelector('.card-size-selector__add-btn');
    addBtn.disabled = false;
    addBtn.dataset.variantId = button.dataset.variantId;
    addBtn.textContent = 'Add to cart';
    return;
  }

  // Handle Add to cart click
  const addBtn = event.target.closest('.card-size-selector__add-btn');
  if (addBtn) {
    event.preventDefault();
    event.stopPropagation();

    if (!addBtn.dataset.variantId) return;
    if (addBtn.disabled) return; // prevent double-clicks mid-request

    const originalText = 'Add to cart';
    addBtn.disabled = true;
    addBtn.textContent = 'Adding...';

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: addBtn.dataset.variantId, quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status) {
          alert(data.description || 'Unable to add to cart');
          addBtn.disabled = false;
          addBtn.textContent = originalText;
          return;
        }

        const parser = new DOMParser();
        const newDrawerDoc = parser.parseFromString(data.sections['cart-drawer'], 'text/html');
        const newDrawerContent = newDrawerDoc.querySelector('cart-drawer');
        const currentDrawer = document.querySelector('cart-drawer');

        if (newDrawerContent && currentDrawer) {
          currentDrawer.className = newDrawerContent.className;
          currentDrawer.innerHTML = newDrawerContent.innerHTML;
        }

        if (data.sections['cart-icon-bubble']) {
          const newBubbleDoc = parser.parseFromString(data.sections['cart-icon-bubble'], 'text/html');
          const newBubble = newBubbleDoc.querySelector('.cart-count-bubble');
          const currentBubble = document.querySelector('.cart-count-bubble');
          if (newBubble && currentBubble) {
            currentBubble.outerHTML = newBubble.outerHTML;
          } else if (newBubble) {
            document.querySelector('#cart-icon-bubble')?.insertAdjacentHTML('beforeend', newBubble.outerHTML);
          }
        }

        if (currentDrawer) {
          currentDrawer.classList.add('active');
          document.body.classList.add('overflow-hidden');
          const overlay = currentDrawer.querySelector('#CartDrawer-Overlay');
          if (overlay) {
            overlay.addEventListener('click', () => {
              currentDrawer.classList.remove('active');
              document.body.classList.remove('overflow-hidden');
            });
          }
        }

        // Show success state
        addBtn.textContent = 'Added ✓';

        // Reset back to normal after a short delay
        setTimeout(() => {
          addBtn.textContent = originalText;
          addBtn.disabled = false;
        }, 1500);
      })
      .catch(() => {
        addBtn.disabled = false;
        addBtn.textContent = originalText;
        alert('Something went wrong. Please try again.');
      });
  }
});